(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jsc-render-ballot-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const customWidget = document.querySelector(".evey-widget-custom");

  function checkForATC() {
    const ballotContainers = document.querySelectorAll("[id^='jsc-ballot-']");
    let showWidget = false;

    ballotContainers.forEach(container => {
      // Check if this container is visible
      const isVisible = window.getComputedStyle(container).display !== "none";

      if (isVisible) {
        // Look for the add to cart form or button
        const hasATC = container.querySelector("form[action*='/cart/add'], button[name='add'], .shopify-buy__btn, [data-evey-tickets]");
        if (hasATC) {
          showWidget = true;
        }
      }
    });

    customWidget.style.display = showWidget ? "block" : "none";
  }

  // Initial check
  checkForATC();

  // Observe DOM for changes
  const observer = new MutationObserver(checkForATC);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
  } catch(e) { console.error(e); }
})();

})();
